/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.2.6
* 
*******************************************************************************/
let types={BD:"bd",CONSOLE:"console",CONSOLE_MONITOR:"console-monitor",EMULATOR:"emulator",HOME_THEATRE:"home-theatre",MONITOR:"monitor",PHONE:"phone",STB:"stb",TABLET:"tablet",TV:"tv",UNKNOWN:"unknown",WORKSTATION:"workstation"};export default{DEVICE_TYPE:types,DEFAULT:{MODEL:"dummyModel",FIRMWARE_VERSION:"dummyFirmwareVersion",DEVICE_YEAR:0,FIRMWARE_YEAR:0,LOCATION:"dummyLocation",COUNTRY:"dummyCountry",WIDTH:0,HEIGHT:0,RESOLUTION:{width:0,height:0}}};